import { InjectionToken } from '@angular/core';
import type { MultipleFileUploadConfig } from '@pct-ng/feature-file-upload-native';

export const GALLERY_IMAGE_CONFIG_INJECTION_TOKEN = new InjectionToken<MultipleFileUploadConfig>(
  'gallery-image-injection-config-token',
);
